import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    .element-group {
        display: flex;
        align-items: center;

        &.disabled {
            .element {
                pointer-events: none;
            }
        }

        &.truncate {
            .element {
                width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .element-divider {
            padding: 0 .5em;
            color: ${vars.colorTextWhite};
        }

        .element {
            display: inline-block;
            margin-right: 1em;
            font-size: .85em;
            color: ${vars.colorTextWhite};
            text-decoration: none;

            &.active {
                color: ${vars.colorViolet};
            }

            &:hover {
                opacity: 0.8;
            }

            &:last-of-type {
                margin-right: 0;
            }
        }
    }
`;
